import script from "./DiscountDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscountDialog.vue?vue&type=script&setup=true&lang=js"

import "./DiscountDialog.vue?vue&type=style&index=0&id=5d393f8e&scopped=true&lang=css"

const __exports__ = script;

export default __exports__